import { render } from "./StoreTransactionModal.vue?vue&type=template&id=054cba10"
import script from "./StoreTransactionModal.vue?vue&type=script&lang=js"
export * from "./StoreTransactionModal.vue?vue&type=script&lang=js"

import "./StoreTransactionModal.vue?vue&type=style&index=0&id=054cba10&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__